import type { CredentialShape, ScimIdpType } from '../../../services';

// Client-side mirror of `IDP_CREDENTIAL_SHAPES` in
// server/apps/scim/api/serializers.py. Lets the drawer derive the shape
// from the in-form `idp_type` selection (so the field set updates as
// the admin switches between Okta / Azure / Duo) instead of waiting on
// the backend `credential_shape` on the saved detail, which only
// reflects whatever type was last persisted.
//
// Keep in sync with the backend and with the per-IdP setup runbooks
// (doc/admin-guides/*-integration-setup.md).

export const CREDENTIAL_SHAPES: Record<ScimIdpType, CredentialShape> = {
  google: {
    description: 'Google service account JSON + admin_email',
    required_keys: ['admin_email', 'client_email', 'private_key'],
    example_keys: [
      'type',
      'project_id',
      'private_key_id',
      'private_key',
      'client_email',
      'client_id',
      'admin_email',
    ],
  },
  duo: {
    description: 'Duo Admin API credentials',
    required_keys: ['integration_key', 'secret_key', 'api_hostname'],
    example_keys: ['integration_key', 'secret_key', 'api_hostname'],
  },
  okta: {
    description: 'Okta API token and org URL',
    required_keys: ['api_token', 'org_url'],
    example_keys: ['api_token', 'org_url'],
  },
  azure: {
    description: 'Microsoft Entra ID (Azure AD) application credentials',
    required_keys: ['tenant_id', 'client_id', 'client_secret'],
    example_keys: ['tenant_id', 'client_id', 'client_secret'],
  },
};

export function credentialShapeFor(
  type: ScimIdpType | undefined,
): CredentialShape | null {
  if (!type) return null;
  return CREDENTIAL_SHAPES[type] ?? null;
}
